<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from 'vuex';
import { setHaptic } from "@/tools/setTelegramHaptick";
import icons from '@/models/icons'
import iconMapping from '@/models/iconmapping'
import packagingMap from '@/models/packaging'
import { Item } from '@/models/order_scan_models/orderScan'

const props = defineProps<{
  item: Item,
}>();

const iconPath = computed(() => icons[iconMapping[props.item.description.split(';')[0].trim()]] || '');
const packaging = computed(() => packagingMap[props.item.packaging] || props.item.packaging);


</script>

<template>

  <Transition name="fade">
    <div class="order-item">
      <p :style="{ backgroundColor: props.item.scannedQuantity >= props.item.orderQuantity ? 'var(--green-color)' : 'var(--orange-color)' }" class="item__quantity">{{ props.item.scannedQuantity }}/{{ props.item.orderQuantity }}</p>
      <div class="item__info">
        <div class="item__icon">
          <img v-if="iconPath" class="item__img" :src="iconPath">
        </div>
        <div class="item__texts">
          <div class="item__name">{{ props.item.name }}</div>
          <div class="item__packaging">{{ packaging }}</div>
          <div class="item__description">{{ props.item.description }}</div>
        </div>
      </div>
    </div>
  </Transition>

</template>

<style scoped>

.btn {
  border: none;
  outline: none;
  cursor: pointer;
  background: none;
  font-family: inherit;
  -webkit-tap-highlight-color: transparent;
  font-size: 14px;
  padding: 12px 20px;
  border-radius: var(--border-radius);
  color: black;
  box-shadow: var(--drop-shadow-item);
  /* width: 100%; */
}

.button__all_product_add {
  background-color: var(--green-color);
  width: 100%;
}

.button__enter-count {
  background-color: var(--orange-color);
  background-color: var(--grey-color);
  padding: 12px;
  display: flex;
}

.item__buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}

.item__packaging {
  font-size: 14px;
  color: black;
  font-weight: 600;
  text-align: start;
}

.item__description {
  font-size: 11px;
  color: #8E8E92;
  text-align: start;
}

.item__name {
  font-size: 14px;
  color: black;
  text-align: start;
}

.item__texts {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 5px;
}

.item__img {
  width: 47px;
}

.item__quantity{
  position: absolute;
  /* top: 50%;
  right: -15px;
  transform: translateY(-50%); */
  bottom: 0;
  right: 0;
  box-sizing: border-box;
  background-color: var(--orange-color);
  color: white;
  font-weight: 600;
  font-size: 18px;
  padding: 10px 15px 10px 15px;
  /* border-radius: var(--border-radius); */
  border-top-left-radius: var(--border-radius);
  box-shadow: var(--drop-shadow-item);
}

.item__icon {
  position: relative;
  display: flex;
  max-width: 47px;
  max-height: 47px;
}

.item__info {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  gap: 20px;
}

.order-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px 10px;
  box-sizing: border-box;
  background-color: white;
  box-shadow: var(--drop-shadow-item);
  border-radius: var(--border-radius);
  width: 100%;
  position: relative;
  overflow: hidden;
}

</style>